export const USER = 'USER';
export const AUTHENTICATION = 'AUTHENTICATION';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const RESTORE_PASSWORD = 'RESTORE_PASSWORD';
export const RESTORE_LINK_DECRYPT = 'RESTORE_LINK_DECRYPT';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
